import React from 'react';
import {
    DrawerHeader, Select,
} from '@paretogroup/tess';
import { stringToSelectOption } from '@shared/select/select.utils';
import {
    FILTER_DRAWER_HEADER_AUTO_TESTS_IDS,
    FILTER_DRAWER_HEADER_TEXT,
} from './filter-drawer-header.constants';
import {
    AvailableFiltersWrapper,
    Text,
    TextWrapper,
} from './filter-drawer-header.styles';
import { buildCustomFiltersOptions, getConditionsText } from './filter-drawer-header.utils';
import { useCampaignFilterRules } from '../../rules';
import { useCampaignFilters } from '../../filters';
import { useCampaignFilterInterface } from '../../interface';

export const FilterDrawerHeader = () => {
    const { rulesCount } = useCampaignFilterRules();
    const { filters } = useCampaignFilters();
    const { onChangeCustomFilters } = useCampaignFilterInterface();
    const { activeFilter, customFilters } = filters;

    return (
        <DrawerHeader
            avatar=""
            headerTitle={FILTER_DRAWER_HEADER_TEXT.TITLE}
            headerSubtitle={FILTER_DRAWER_HEADER_TEXT.SUBTITLE}
        >
            <AvailableFiltersWrapper>
                <TextWrapper>
                    <Text>{FILTER_DRAWER_HEADER_TEXT.AVAILABLE_FILTERS}</Text>
                    <Text>{getConditionsText(rulesCount)}</Text>
                </TextWrapper>
                <Select
                    options={buildCustomFiltersOptions(customFilters)}
                    onChange={(newValue) => { onChangeCustomFilters(newValue); }}
                    value={stringToSelectOption(activeFilter?.name)}
                    data-auto-testid={FILTER_DRAWER_HEADER_AUTO_TESTS_IDS.SELECT_FILTERS}
                />
            </AvailableFiltersWrapper>
        </DrawerHeader>
    );
};
